import { render, staticRenderFns } from "./PeriodView.vue?vue&type=template&id=443f907c&"
import script from "./PeriodView.vue?vue&type=script&lang=js&"
export * from "./PeriodView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports